<template>
  <img :src="`/static/images/svg/${name}.svg`" alt="">
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Icon.vue